<template>
    <NodeAllocationPage :admin="true" />
</template>

<script>
import NodeAllocationPage from '@/modules/user/components/NodeAllocationPage.vue'

export default {
    name: 'TheAdminNodeAllocation',
    components: { NodeAllocationPage }
}
</script>
